import { render } from "./profession-settings.vue?vue&type=template&id=2a551836"
import script from "./profession-settings.vue?vue&type=script&lang=js"
export * from "./profession-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__